import { useEffect, useState } from 'react'
import IssuesService from '../../../services/api/IssuesService'
import { showToast } from '../../shared/Toast'

const LOAD_ERROR_MSG = 'Impossible de charger les utilisateurs. Veuillez réessayer plus tard.'

const noop = () => null

const toOption = option => ({
  value: option.user_id,
  label: option.user_name,
  roleLabel: option.role_label
})

const useAssignableUsers = (collectId, isOpen, toastContainerId = null) => {
  const [options, setOptions] = useState([])

  useEffect(() => {
    if (!isOpen)
      return noop
    let cancelled = false
    IssuesService.getAssignableUsers(collectId).then(response => {
      if (cancelled)
        return
      setOptions((response || []).map(toOption))
    }).catch(() => {
      if (cancelled)
        return
      showToast(LOAD_ERROR_MSG, 'error', toastContainerId)
    })
    return () => {
      cancelled = true
    }
  }, [collectId, isOpen, toastContainerId])

  return options
}

export default useAssignableUsers
